import qs from 'qs';
import client from '@/api/base';

export default {
  async getPulseEngagement() {
    const response = await client.get('/coaching/engagement/pulse/');
    return response;
  },

  async getPulseReportLeader(params) {
    const response = await client.get(`/coaching/engagement/pulse/report/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getLeaderPulse(id, params) {
    const response = await client.get(`/coaching/engagement/leader/${id}/pulse/report/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getSupporterPulseSurvey(id) {
    const response = await client.get(`/coaching/supporter/${id}/pulse-survey/`);
    return response;
  },

  async publishSupporterPulseSurvey(id, data) {
    const response = await client.post(`/coaching/supporter/${id}/pulse-survey/`, data);
    return response;
  },

  async getLeaderPulseSurvey() {
    const response = await client.get('/coaching/leader/pulse-survey/');
    return response;
  },

  async publishLeaderPulseSurvey(data) {
    const response = await client.post('/coaching/leader/pulse-survey/', data);
    return response;
  },

  async getPulseReportCoach(id) {
    const response = await client.get(`/coaching/leader/${id}/pulse/report/`);
    return response;
  },

  async getPulseResponse(id) {
    const response = await client.get(`/coaching/engagement/pulse/survey/${id}/`);
    return response;
  },

  async patchPulseResponse(id, data) {
    const response = await client.patch(`/coaching/engagement/pulse/survey/${id}/`, data);
    return response;
  },
};
